module.exports = __webpack_public_path__ + "img/trend_black.5ce162ea.svg";